<template>
    <TextList :value="listValue" @input="emitAnswer($event)" :type="type" :min="minItems" :max="maxItems"></TextList>
</template>

<script>
  import responseMixin from "./responseMixin";
  import TextList from "./components/TextList";

  export default {
    name: "TestListResponse",
    mixins: [responseMixin],
    components: {
      TextList
    },
    computed: {
      minItems() {
        if (!this.questionresponse) {
          return 1;
        }
        return this.questionresponse.min_length || 1;
      },
      maxItems() {
        if (!this.journeyanswers) {
          return 1;
        }
        return this.journeyanswers.length;
      },
      type() {
        if (!this.questionresponse) {
          return 'field';
        }
        return this.questionresponse.response_type === 'textarea_list' ? 'area' : 'field';
      },
      listValue() {
        if (!this.value) {
          return [];
        }
        const vals = [];
        for (let ja of this.journeyanswers) {
          const val = this.value.answers[ja.journeyanswerid].value;
          if (val) {
            vals.push(val);
          }
        }
        return vals;
      },
      copiedValue() {
        return JSON.parse(JSON.stringify(this.value));
      }
    },
    methods: {
      emitAnswer(arr) {
        const result = this.copiedValue;
        let i = 0;
        for (let id of Object.keys(this.journeyanswers)) {
          const ja=this.journeyanswers[id];
          result.answers[ja.journeyanswerid].value = null;
          if(i<arr.length){
            result.answers[ja.journeyanswerid].value=arr[i];
          }
          i++;
        }
        this.emitInput(result);
      }
    }
  }
</script>

<style scoped>

</style>